module.exports = __webpack_public_path__ + "static/media/info-muren.16c6ddbe.JPG";